import { API_BASE_URL } from '../../config/bootstrap';

export const startCollection = async (
  taskDefId: string,
  variant = 'run',
  inputs: Record<string, string> = {}
): Promise<string> => {
  const response = await fetch(`${API_BASE_URL}/collect/start`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ taskDefId, variant, inputs }),
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `Failed to start collection (${response.status})`);
  }
  const payload = await response.json();
  if (!payload.authorizeUrl) {
    throw new Error('No authorize URL returned');
  }
  return payload.authorizeUrl as string;
};
